import { render, staticRenderFns } from "./order-manage-detail.vue?vue&type=template&id=23289c64&scoped=true&"
import script from "./order-manage-detail.vue?vue&type=script&lang=js&"
export * from "./order-manage-detail.vue?vue&type=script&lang=js&"
import style0 from "./order-manage-detail.vue?vue&type=style&index=0&id=23289c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23289c64",
  null
  
)

export default component.exports